import { GlFilteredSearchSuggestion } from '../../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import BaseToken from '../../../../../../../../app/assets/javascripts/vue_shared/components/filtered_search_bar/tokens/base_token.vue?vue3';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
import { OPTIONS_NONE_ANY, WEIGHT_TOKEN_SUGGESTIONS_SIZE } from '../constants';
const weights = Array.from(Array(WEIGHT_TOKEN_SUGGESTIONS_SIZE), (_, index)=>index.toString());
export default {
    name: 'WeightToken',
    components: {
        BaseToken,
        GlFilteredSearchSuggestion
    },
    mixins: [
        glListenersMixin
    ],
    props: {
        active: {
            type: Boolean,
            required: true
        },
        config: {
            type: Object,
            required: true
        },
        value: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            weights
        };
    },
    computed: {
        defaultWeights () {
            return this.config.defaultWeights || OPTIONS_NONE_ANY;
        }
    },
    methods: {
        getActiveWeight (weightSuggestions, data) {
            return weightSuggestions.find((weight)=>weight === data);
        },
        updateWeights (searchTerm) {
            const weight = parseInt(searchTerm, 10);
            this.weights = Number.isNaN(weight) ? weights : [
                String(weight)
            ];
        }
    }
};
